// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 524 ? "2170a4aa" : chunkId) + "." + {"436":"423bff32fd4fbec0","524":"ba67d0e650daa11e"}[chunkId] + ".js";
};